module.exports = __webpack_public_path__ + "static/media/down.0c3ac35e.svg";